"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossiblePolicySchema = exports.canceledDateSchema = exports.renewalDateSchema = exports.issueDateSchema = exports.dateIsAfterMinDefaultDate = exports.dateRetrievedIsValid = exports.MIN_ISSUE_DATE_ISO = exports.MIN_RETRIEVED_DATE_ISO = void 0;
const zod_1 = require("zod");
const PolicyHolder_1 = require("./PolicyHolder");
const PersonalAutoDiscount_1 = require("./PersonalAutoDiscount");
const PropertyDiscount_1 = require("./PropertyDiscount");
const enums_1 = require("../enums");
const numbers_1 = require("../numbers");
const constants_1 = require("../constants");
const dates_1 = require("../dates");
const Payment_1 = require("./Payment");
exports.MIN_RETRIEVED_DATE_ISO = '2019-09-01';
exports.MIN_ISSUE_DATE_ISO = '2000-01-01';
const getDateInFiveYears = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 5);
    return date.toISOString();
};
const dateRetrievedIsValid = (isoDate) => (0, dates_1.dateIsAfterMinimumDate)(isoDate, exports.MIN_RETRIEVED_DATE_ISO);
exports.dateRetrievedIsValid = dateRetrievedIsValid;
const dateIsAfterMinDefaultDate = (isoDate) => (0, dates_1.dateIsAfterMinimumDate)(isoDate, exports.MIN_ISSUE_DATE_ISO);
exports.dateIsAfterMinDefaultDate = dateIsAfterMinDefaultDate;
exports.issueDateSchema = zod_1.z.nullable(zod_1.z
    .string()
    .regex(constants_1.REGEX.iso8601Date)
    .refine(exports.dateIsAfterMinDefaultDate, { message: `Date issued should be after ${exports.MIN_ISSUE_DATE_ISO}` })
    .refine(date => (0, dates_1.dateIsBeforeMaximumDate)(date, getDateInFiveYears()), { message: 'Date issued should be 5 years in the future maximum' })
    .optional());
exports.renewalDateSchema = zod_1.z.nullable(zod_1.z
    .string()
    .regex(constants_1.REGEX.iso8601Date)
    .refine(exports.dateIsAfterMinDefaultDate, { message: `Renewal date should be after ${exports.MIN_ISSUE_DATE_ISO}` })
    .refine(date => (0, dates_1.dateIsBeforeMaximumDate)(date, getDateInFiveYears()), { message: 'Renewal date should be 5 years in the future maximum' })
    .optional());
exports.canceledDateSchema = zod_1.z.nullable(zod_1.z
    .string()
    .regex(constants_1.REGEX.iso8601Date)
    .refine(exports.dateIsAfterMinDefaultDate, { message: `Date issued should be after ${exports.MIN_ISSUE_DATE_ISO}` })
    .refine(dates_1.dateIsBeforeOrEqualToPresent, { message: 'Date should be the present date or earlier' })
    .optional());
exports.impossiblePolicySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    issuer: zod_1.z.nativeEnum(enums_1.AllIssuers),
    policyNumber: zod_1.z.string().min(6).max(24).regex(constants_1.REGEX.defaultString),
    policyType: zod_1.z.nativeEnum(enums_1.PolicyTypes),
    policyHolder: zod_1.z.nullable(PolicyHolder_1.impossiblePolicyHolderSchema).optional(),
    dateRetrieved: zod_1.z.nullable(zod_1.z.string().regex(constants_1.REGEX.iso8601DateTime).refine(exports.dateRetrievedIsValid)),
    canceledDate: exports.canceledDateSchema,
    policyTermMonths: zod_1.z.nullable(zod_1.z.literal(6).or(zod_1.z.literal(12))).optional(),
    paymentScheduleMonths: zod_1.z.nullable(zod_1.z.number().min(1).max(12)).optional(),
    numberOfPayments: zod_1.z.nullable(zod_1.z.number().min(1).max(12)).optional(),
    issueDate: exports.issueDateSchema,
    renewalDate: zod_1.z.nullable(exports.renewalDateSchema).optional(),
    active: zod_1.z.boolean().optional(),
    premiumCents: zod_1.z.nullable(zod_1.z.number().gt(0).lt((0, numbers_1.million)(5))).optional(),
    discountTotalCents: zod_1.z.nullable(zod_1.z.number().min(0).lt((0, numbers_1.million)(5))).optional(),
    discounts: zod_1.z.nullable(zod_1.z.array(zod_1.z.union([PropertyDiscount_1.impossiblePropertyDiscountSchema, PersonalAutoDiscount_1.impossiblePersonalAutoDiscountSchema]))).optional(),
    paymentHistory: zod_1.z.nullable(zod_1.z.array(Payment_1.impossiblePaymentSchema)).optional(),
}).strict();
